{
  "JOB_INFORMATION": "Job Information",
  "PRESETS": "Presets",
  "CUSTOM": "Custom",
  "SELECT_PRESET": "Select Preset",
  "YES": "Yes",
  "NO": "No",
  "STANDARD_REDACTION_ITEMS": "Standard Redaction Items",
  "LOCATION": "Location",
  "PRESET": "Preset",
  "NEXT": "Next",
  "MODIFY_LIST": "Modify List",
  "MARKUP_TYPE": "Markup Type",
  "CUSTOM_ITEMS": "Custom Items",
  "ADD_CUSTOM": "Add Custom",
  "EDIT_CUSTOM": "Edit Custom",
  "ADD_CUSTOM_WORD_OR_PHRASE": "Add Custom Word or Phrase",
  "MATCH_CRITERIA": "Match Criteria",
  "CONTAINS": "Contains",
  "MATCHES": "Matches",
  "CUSTOM_WORD_OR_PHRASE": "Custom Word or Phrase",
  "CUSTOM_WORDS_OR_PHRASES": "Custom Words or Phrases",
  "SAVE_PRESET": "Save Preset",
  "DELETE_PRESET": "Delete Preset?",
  "PRESET_NAME": "Preset Name",
  "OVERWRITE_PRESET": "Overwrite {{preset}}?",
  "SAVE_AS_NEW_PRESET": "Save as New Preset",
  "PRESET_SAVED": "Preset Saved",
  "OVERWRITE": "Overwrite",
  "DELETE": "Delete",
  "STANDARD_REDACTION_CUSTOM_ITEM_MUST_BE_SELECTED": "A Standard Redaction or Custom Item must be selected.",
  "SELECT_PROFILE_FOR_DETAILS": "Select Preset to view details.",
  "PRESET_NOT_MODIFIED": "Preset has not been modified. Change settings to save or overwrite.",
  "DELETE_PRESET_PROMPT": "This will permanently delete the following preset.",
  "EDIT_REDACTION_ITEMS": {
    "CANNOT_ADD_ALL": "Adding all recent recipients will exceed the maximum number or recipients allowed.",
    "CANNOT_ADD_ALL_TITLE": "Cannot Add All",
    "ITEMS": "Items",
    "SELECT_ALL": "Select All",
    "STANDARD_TITLE": "Standard Redaction Items",
    "NUMBER_SELECTED": "Selected: {{numberSelected}} of {{numberTotal}}",
    "SEARCH": "Search"
  },
  "LOCATIONS": {
    "ARGENTINA": "Argentina",
    "ARMENIA": "Armenia",
    "AUSTRALIA": "Australia",
    "AZERBAIJAN": "Azerbaijan",
    "BELARUS": "Belarus",
    "BELGIUM": "Belgium",
    "BRAZIL": "Brazil",
    "CANADA": "Canada",
    "CHILE": "Chile",
    "CHINA": "China",
    "COLOMBIA": "Colombia",
    "CROATIA": "Croatia",
    "DENMARK": "Denmark",
    "FINLAND": "Finland",
    "FRANCE": "France",
    "GERMANY": "Germany",
    "HONG_KONG": "Hong Kong",
    "INDIA": "India",
    "INDONESIA": "Indonesia",
    "IRELAND": "Ireland",
    "ISRAEL": "Israel",
    "ITALY": "Italy",
    "JAPAN": "Japan",
    "KOREA": "Korea",
    "MEXICO": "Mexico",
    "NETHERLANDS": "The Netherlands",
    "NEW_ZEALAND": "New Zealand",
    "NORWAY": "Norway",
    "PARAGUAY": "Paraguay",
    "PERU": "Peru",
    "POLAND": "Poland",
    "PORTUGAL": "Portugal",
    "RUSSIA": "Russia",
    "SCOTLAND": "Scotland",
    "SINGAPORE": "Singapore",
    "SOUTH_AFRICA": "South Africa",
    "SPAIN": "Spain",
    "SWEDEN": "Sweden",
    "SWITZERLAND": "Switzerland",
    "TAIWAN": "Taiwan",
    "THAILAND": "Thailand",
    "TURKEY": "Turkey",
    "UK": "United Kingdom",
    "UKRAINE": "Ukraine",
    "URUGUAY": "Uruguay",
    "US": "United States",
    "UZBEKISTAN": "Uzbekistan",
    "VENEZUELA": "Venezuela"
  },
  "EMAIL_SUBJECT": "Subject",
  "ENTER_EMAIL_SUBJECT": "Enter Email Subject",
  "EMAIL_SUBJECT_INPUT_TITLE": "Email Subject",
  "EMAIL_RECIPIENT": "Recipient",
  "TWO_SIDED_PRINTING": "2-Sided Printing",
  "QUANTITY": "Quantity",
  "CANCEL": "Cancel",
  "CANNOT_ADD_RECIPIENT": "Cannot Add Recipient",
  "ECOMMERCE": {
    "PAYMENT_REQUIRED": "Not available. A payment is required",
    "REMAINING_BALANCE": "Your credit balance is: {{credits}}",
    "TITLE": "Credit Balance"
  },
  "EDIT_ATTACHMENT_NAME": "Edit Attachment Name",
  "EMAIL_ADDRESS_INPUT_LABEL": "Email Address",
  "ERROR": {
    "API_KEY_ERROR": "This application requires an update. Please visit the Xerox App Gallery.",
    "APP_UNAVAILABLE": "Auto-Redaction App Unavailable",
    "APP_UNAVAILABLE_TRY_AGAIN": "The Autoredact app is unavailable at this time. Try again.",
    "CHARACTERS_CANNOT_BE_USED": "These characters cannot be used: ? ; | : ’ * % ^ & # + ` \\ / ~ '",
    "CLOSE_ALERT_CONTINUE_WORKING": "You can close this alert and continue working",
    "CONTACT_XEROX_SUPPORT": "If the problem persists, contact Xerox support.",
    "CONTACT_YOUR_DEVICE_ADMINISTRATOR": "Contact your device administrator to enable these services.",
    "DEVICE_CONFIGURATION": "Device Configuration",
    "EIP_SERVICES": "To use this app, the following web services must be enabled:",
    "EIP_SERVICES_DISABLED": "Web services disabled",
    "EMAIL_ERROR": "Email Error",
    "EMAIL_FORMAT_ERROR": "Enter a valid email (username@example.com).",
    "EMAIL_NOT_SENT": "The summarization email was not sent.",
    "ENTER_DIFFERENT_FILENAME": "Enter a different filename and try again.",
    "ENTER_EMAIL": "Enter an email.",
    "ENTER_EMAIL_RECIPIENT": "Enter Recipient",
    "ERROR_HAS_OCCURRED": "An error has occurred.",
    "ERROR_OCCURED_DURING_SUMMARIZATION": "An error occurred during summarization.",
    "ERROR_OCCURED_DURING_SUMMARY": "An error has occurred generating the summary.",
    "FILENAME_LENGTH_ERROR": "Attachment name cannot be longer than 128 characters.",
    "IF_PROBLEM_PERSISTS_CONTACT_XEROX": "If the problem persists, contact Xerox support.",
    "INSTALLING_APP_UPDATES": "Installing App Updates",
    "JOB_MANAGEMENT_EXTENSION": "Job Management Extension",
    "MAXIMUM_FILE_SIZE_IS": "The maximum file size is: {{maxSize}}MB",
    "MAXIMUM_RECIPIENTS_REACHED": "The maximum number of recipients has been reached.",
    "PLEASE_TRY_AGAIN": "Please try again.",
    "PROCESSING_ERROR": "Processing Error",
    "REDUCE_PAGES_AND_TRY_AGAIN": "Reduce the number of pages scanned and try again. If the problem persists, contact Xerox support to check app configuration.",
    "SCAN_ERROR": "Scan Error",
    "SCAN_EXTENSION": "Scan Extension",
    "SCAN_FILE_SIZE_EXCEEDS_LIMIT": "Maximum File Size Exceeded",
    "SCAN_TEMPLATE_MANAGEMENT": "Scan Template Management",
    "SUMMARIZATION_ERROR": "Summarization Error",
    "SUMMARY_GENERATING_TITLE": "Summary Generating Error",
    "THIS_MAY_TAKE_SEVERAL_MINUTES": "This may take several minutes",
    "TRY_AGAIN": "Try again.",
    "TRY_AGAIN_LATER": "Please try again later.",
    "TRY_SCANNING_AGAIN": "Try scanning your document again.",
    "ENTER_PRESET_NAME": "Enter a preset name",
    "NAME_ALREADY_EXISTS": "A preset with this name already exists.",
    "ENTER_CUSTOM_WORD_OR_PHRASE": "Enter a custom word or phrase.",
    "EMAIL_SUBJECT_REQUIRED": "Email Subject required.",
    "ECOMMERCE_ERROR_TITLE": "Error Calling Ecommerce API",
    "ECOMMERCE_TIMEOUT_TITLE": "Ecommerce Timeout",
    "API_ERROR_TITLE": "Error Calling App API",
    "GENERIC_ERROR_DESCRIPTION": "Try again later. If the problem persists, contact Xerox support.",
    "REDACTION_ERROR_TITLE": "Unable to Complete Redaction",
    "REDACTION_REQUEST_ERROR_TITLE": "Unable to Complete Request",
    "PRESETS_ERROR_TITLE": "Cannot Access Presets",
    "JOB_INFO_ERROR_TITLE": "Job Information Access Disabled",
    "JOB_INFO_ERROR_DESCRIPTION": "Contact your device administrator to enable this setting."
  },
  "EULA": {
    "ACCEPT": "Agree",
    "CONSENT_PROMPT": "The use of Autoredact app is subject to terms and conditions set forth in the application's End-User License Agreement.",
    "LICENSE_AGREEMENT": "License Agreement",
    "TITLE": "End User License Agreement",
    "VIEW_EULA": "View End User License Agreement"
  },
  "LOADING": "Loading...",
  "MAIN_TITLE": "Auto-Redaction",
  "MAIN_TITLE_HYPHEN": "Auto-Redaction",
  "MAX_RECIPIENTS": "The maximum is:",
  "MAXIMUM_RECIPIENTS": "Maximum Recipients",
  "NAME": "Name",
  "NO_RECIPIENTS": "No Recipients",
  "OK": "OK",
  "ONE_SIDED": "1-Sided",
  "ORIGINAL_SIZE": "Original Size",
  "PORTRAIT": "Portrait",
  "PREVIEW": {
    "CANCEL_JOB_CANCEL": "Close",
    "CANCEL_JOB_DISCARD": "Discard",
    "CANCEL_JOB_TEXT": "Your account has already been charged for this job. Are you sure you want to discard this summary?",
    "CANCEL_JOB_TITLE": "Cancel Job?",
    "CONTINUE": "Continue",
    "OK": "OK",
    "TITLE": "Preview",
    "PAGE_COUNT": "Pages"
  },
  "PRIVACY": {
    "ACCEPT": "Continue",
    "CLOSE": "Cancel",
    "CONSENT_PROMPT": "By using the Autoredact app, you consent to Xerox's processing of personal information you provide as set forth in Xerox's Privacy Statement.",
    "CONSENT_PROMPT_ADDITIONAL": "When using some features of the Auto-Redaction app Xerox may process personal information at your direction. By using the Auto-Redaction app you consent to Xerox's processing of personal information as set forth in Xerox's privacy statement. More information can be found in the documentation for the app.",
    "POPUP_TITLE": "Xerox Privacy Statement",
    "TITLE": "Privacy Statement",
    "VIEW_STATEMENT": "View Xerox Privacy Statement"
  },
  "RECIPIENTS": "Recipients",
  "REMAINING_CREDITS": "Remaining Credits",
  "SCAN": {
    "REDACTION_SETTINGS": "Redaction Settings",
    "ENTER_EMAIL_ADDRESS": "Enter Email Address",
    "ADD_RECIPIENTS": "Recipient",
    "CANCEL_JOB": "Cancel Job",
    "CANCELLING": "Canceling Your Job...",
    "COMPLETED": "Job Complete",
    "EMAIL": "Email",
    "EMAILING": "Emailing Results...",
    "ENABLE_PRINT_OR_EMAIL": "Print or email must be enabled.",
    "FEATURE_SETTINGS": "Scan Settings",
    "INCLUDE_ORIGINAL": "Include Original",
    "JOB_PROGRESS": "Job Progress",
    "OUTPUT_SETTINGS": "Output Results",
    "PREVIEW": "Preview",
    "PRINT": "Print",
    "PRINTING": "Printing...",
    "PRINTING_AND_EMAILING": "Printing and Emailing...",
    "PROCESSING": "Processing...",
    "SCAN": "Scan",
    "SCAN_CANCELED": "Your job has been canceled.",
    "SCANNING": "Scanning...",
    "START": "Start"
  },
  "SCAN_SETTINGS": {
    "100_DPI": "100 dpi",
    "11X17": "11 x 17\"",
    "150_DPI": "150 dpi",
    "200_DPI": "200 dpi",
    "300_DPI": "300 dpi",
    "400_DPI": "400 dpi",
    "5_5X7": "5.5 x 7\"",
    "5_5X8_5": "5.5 x 8.5\"",
    "600_DPI": "600 dpi",
    "72_DPI": "72 dpi",
    "8_5X11": "8.5 x 11\"",
    "8_5X13": "8.5 x 13\"",
    "8_5X14": "8.5 x 14\"",
    "AUTO_DETECT": "Auto",
    "ONE_SIDED": "1-Sided",
    "TWO_SIDED_LONG": "2-Sided",
    "TWO_SIDED_SHORT": "2-Sided, Rotate Side 2"
  },
  "SETTINGS_HAVE_BEEN_RESET": "Auto-Redaction settings have been reset.",
  "SPORT": "Sport",
  "TOASTS": {
    "EMAIL_SUBJECT_UPDATED": "Email subject updated.",
    "RECIPIENT_ADDED": "New recipient added.",
    "RECIPIENT_REMOVED": "Recipient removed.",
    "PRESET_MUST_BE_SELECTED": "A preset must be selected."
  },
  "MARKUP_TYPE_SETTINGS": {
    "REDACT": "Redact",
    "HIGHLIGHT": "Highlight",
    "UNDERLINE": "Underline"
  },
  "TWO_SIDED_LONG": "2-Sided",
  "TWO_SIDED_SCANNING": "2-Sided Scanning",
  "TWO_SIDED_SHORT": "2-Sided, Rotate Side 2"
}
